import { Phone, Mail, MapPin, Instagram, Linkedin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-kw-ink text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <h3 className="font-serif text-5xl sm:text-6xl tracking-tight leading-none">{BRAND.name}</h3>
            <p className="overline text-kw-red mt-3">{BRAND.brokerage}</p>
            <p className="mt-6 text-neutral-400 max-w-md leading-relaxed text-sm">
              Strategic real estate in Denver, Colorado. The most money, in the least time, with the
              least stress — backed by a proven plan.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-neutral-500 mb-5">Contact</p>
            <a href={BRAND.phoneHref} className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors mb-3"><Phone size={15} /> {BRAND.phone}</a>
            <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors text-sm mb-3"><Mail size={15} /> {BRAND.email}</a>
            <p className="flex items-start gap-2 text-neutral-300 text-sm" data-testid="footer-address"><MapPin size={15} className="mt-0.5 shrink-0" /> {BRAND.address}</p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-neutral-500 mb-5">Follow</p>
            <div className="flex items-center gap-4">
              <a href={BRAND.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-neutral-300 hover:text-kw-red transition-colors"><Instagram size={20} /></a>
              <a href={BRAND.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-neutral-300 hover:text-kw-red transition-colors"><Facebook size={20} /></a>
              <a href={BRAND.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="text-neutral-300 hover:text-kw-red transition-colors"><Linkedin size={20} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
          <p className="text-xs text-neutral-500 order-2 sm:order-1">
            © {new Date().getFullYear()} {BRAND.name} · {BRAND.brokerage}. All rights reserved.
            <span className="block mt-1">Each Keller Williams office is independently owned and operated.</span>
            <Link to="/terms" data-testid="footer-terms-link" className="inline-block mt-2 text-neutral-400 hover:text-kw-red transition-colors underline underline-offset-2">
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="inline-block mt-2 ml-4 text-neutral-400 hover:text-kw-red transition-colors underline underline-offset-2">
              Privacy Policy
            </Link>
          </p>
          <div className="flex items-center gap-4 order-1 sm:order-2" data-testid="compliance-logos">
            <div className="bg-white p-2.5 flex items-center justify-center" data-testid="equal-housing-logo">
              <img src="/equal-housing.png" alt="Equal Housing Opportunity" className="h-11 w-auto" />
            </div>
            <div className="bg-white p-2.5 flex items-center justify-center" data-testid="realtor-logo">
              <img src="/realtor.png" alt="REALTOR" className="h-11 w-auto" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
